export interface Address {
  address_line_1?: string;
  address_line_2?: string;
  address_line_3?: string;
  address_line_4?: string;
  postal_code?: string;
  country_code?: string;
  PostalCode?: string;
}

export const Address = undefined;
